import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, styled } from "@mui/material";

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const backdropStyles = {
    sx: {
      backgroundColor: 'rgba(52, 48, 48, 0.13)',
      backdropFilter: 'blur(4px)',
    }
};

export const StylesCloseButton = styled(IconButton)(() => ({
    position: 'absolute',
    right: 8,
    top: 10,
    color: '#ACAFBF',
}));

export const StyledDialogTitle = styled(DialogTitle)(() => ({
  fontSize: '18px',
  fontWeight: 600,
  minHeight: '50px',
  margin: 0,
  padding: '16px 24px',
  paddingRight: '50px'
}));

export const StyledDialogContent = styled(DialogContent)(() => ({
  padding: '10px 24px 10px !important'
}));

export const StyledDialogActions = styled(DialogActions)(() => ({
  padding: '14px 24px !important'
}));

export const StyledMobileDialogContent = styled(Box)(() => ({
  padding: '10px 16px 10px'
}));

export const StyledMobileDialogActions = styled(DialogActions)(() => ({
  padding: '12px 16px',
  display: 'flex',
  justifyContent: 'space-between',
}));